/// <reference path="../walkinManager.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.RemoveFromWaitlist {
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    class RemovalModalController {
        static $inject = [
            '$scope', '$rootScope', 'item', '$mdDialog', 'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService', "meevo.components.tracking.TrackingService",
            'meevo.components.common.SecurityService'
        ];
        public item: IWalkinAppointment;
        protected $mdDialog: ng.material.IDialogService;

        constructor(
            protected $scope: ng.IScope,
            protected $rootScope: ng.IRootScopeService,
            item:any,
            $mdDialog: ng.material.IDialogService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected securityService: Meevo.Components.Common.ISecurityService
        ) {
            this.item = item;
            this.$mdDialog = $mdDialog;
        };

        public removeItem (): void {
            this.$mdDialog.hide();
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_WALKINMANAGER_ACTION_DELETEWALKIN)
                .then((response) => {
                    if (response === SecurityAccessEnum.Grant) {
                        this.modalService.confirm('LABEL_WAIT_LIST_REMOVE_CLIENT', ModalTranslationModes.Translate)
                            .then(() => {
                                this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.DeleteButtonClicked, null, this.item.appointmentId));

                                this.busyService.start();
                                this.dataService.patch('walkinAppointment', {
                                    model: {
                                        entityVersion: this.item.entityVersion,
                                        finalStateEnum: Meevo.Model.AppointFinalStateEnum.Cancelled
                                    }
                                }, this.item.id)
                                    .then(() => {
                                        this.$rootScope.$broadcast('startDataLoading');
                                    });
                            });
                    } else {
                        this.modalService.alert('ERROR_HTTP_403');
                    }
                });
        }

        public sendToNoShow(): void {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.ItemNoShowClicked, null, this.item.appointmentId));

            this.$mdDialog.hide();
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_WALKINMANAGER_ACTION_NOSHOWWALKIN)
                .then((response) => {
                    if (response === SecurityAccessEnum.Grant) {
                        this.modalService.confirm('LABEL_WAIT_LIST_NO_SNOW', ModalTranslationModes.Translate)
                            .then(() => {
                                this.busyService.start();
                                this.dataService.patch('walkinAppointment', {
                                    model: {
                                        entityVersion: this.item.entityVersion,
                                        transitionStateEnum: Meevo.Model.AppointStateEnum.WalkInNoShow
                                    }
                                }, this.item.id)
                                    .then(() => {
                                        this.$rootScope.$broadcast('startDataLoading');
                                    });
                            });
                    } else {
                        this.modalService.alert('ERROR_HTTP_403');
                    }
                });
        }

        public sendToWalkout (): void {
            this.$mdDialog.hide();
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_WALKINMANAGER_ACTION_NOSHOWWALKIN)
                .then((response) => {
                    if (response === SecurityAccessEnum.Grant) {
                        this.modalService.confirm('LABEL_WAIT_LIST_WALKOUT', ModalTranslationModes.Translate)
                            .then(() => {
                                this.busyService.start();
                                this.dataService.patch('walkinAppointment', {
                                    model: {
                                        entityVersion: this.item.entityVersion,
                                        transitionStateEnum: Meevo.Model.AppointStateEnum.WalkOut
                                    }
                                }, this.item.id)
                                    .then(() => {
                                        this.$rootScope.$broadcast('startDataLoading');
                                    });
                            });
                    } else {
                        this.modalService.alert('ERROR_HTTP_403');
                    }
                });
        }

        public closeModal (): void {
            this.$mdDialog.cancel();
        }
    }

    angular.module("meevo.plugins.walkinManager")
        .controller("meevo.plugins.walkinManager.removeFromWaitlist.RemovalModalController", RemovalModalController);
}
